import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMetamaskDisconnect } from '../views/home/api/api';

const useAccountWatcher = (address, disconnect) => {
  const [connectedAddress, setConnectedAddress] = useState(address?.toLowerCase() || null);
  const navigate = useNavigate();
  const userDisconnect = useMetamaskDisconnect();

  useEffect(() => {
    const handleAccountsChanged = async (accounts) => {
      if (!accounts || accounts.length === 0) {
        // User disconnected wallet or no account available
        setConnectedAddress(null);
        return;
      }

      const newAddress = accounts[0].toLowerCase();
      const currentAddress = address?.toLowerCase();

      // Only update if changed
      if (newAddress === connectedAddress) return;

      setConnectedAddress(newAddress);

      // If address changed and user has a session, disconnect
      if (sessionStorage.getItem('user_JWT') && newAddress !== currentAddress) {
        try {
          await userDisconnect.mutateAsync({ address: currentAddress });
          await disconnect();

          sessionStorage.clear();
          localStorage.clear();

          navigate('/');
        } catch (err) {
        }
      }
    };

    if (window.ethereum?.on) {
      window.ethereum.on('accountsChanged', handleAccountsChanged);
    }

    return () => {
      if (window.ethereum?.removeListener) {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      }
    };
  }, [address, connectedAddress, disconnect, userDisconnect, navigate]);

  return { connectedAddress };
};

export default useAccountWatcher;
